import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosTodosListaComponent {
  busqueda
  catalogos = {
    gasto_categoria: [],
    moneda: [],
    estatus: [
      {id: 0, descripcion: 'Todos'},
      {id: 1, descripcion: 'Pendientes'},
      {id: 2, descripcion: 'Cerrados'},
      {id: 3, descripcion: 'Completados'},
    ],
  }
  exportando = false
  seleccionado = null
  resultados = undefined
  filtro = {
    general: undefined,
    estatus: 0,
  }
  reporte = 5 // todos

  constructor ($filter, $q, $export, ViaticosTodosService, ViaticosCatalgosCategoriasviaticoService, ViaticosCatalogosMonedasService, ViaticosExportarService) {
    this.filterBy = $filter('filter')
    this.$q = $q
    this.$export = $export
    this.ViaticosTodosService = ViaticosTodosService
    this.ViaticosCatalgosCategoriasviaticoService = ViaticosCatalgosCategoriasviaticoService
    this.ViaticosCatalogosMonedasService = ViaticosCatalogosMonedasService
    this.ViaticosExportarService = ViaticosExportarService
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ViaticosTodosService.get(this.busqueda.fechaInicial, this.busqueda.fechaFinal)
        .then(({data}) => {
          this.data = data
          this.resultados = data
        }),
      this.ViaticosCatalgosCategoriasviaticoService.get()
        .then(({data}) => (this.catalogos.gasto_categoria = data)),
      this.ViaticosCatalogosMonedasService.get()
        .then(({data}) => (this.catalogos.moneda = data)),
    ])
  }

  filtrar () {
    console.log('changed', this.filtro.estatus)
    if (this.filtro.general) {
      this.resultados = this.filterBy(this.data, this.filtro.general)
    } else {
      this.resultados = [...this.data]
    }

    switch (this.filtro.estatus) {
      case 1:
        this.resultados = this.resultados.filter((item) => item.pendiente)
        break
      case 2:
        this.resultados = this.resultados.filter((item) => item.informacion.cerrado)
        break
      case 3:
        this.resultados = this.resultados.filter((item) => !item.pendiente)
        break
      default:
        this.resultados = this.filterBy(this.data, this.filtro.general)
        break
    }

    this.resultadosOcultos = this.data.length - this.resultados.length
  }

  exportar () {
    if (this.exportando) return

    this.exportando = true

    this.ViaticosExportarService.get(this.busqueda.fechaInicial, this.busqueda.fechaFinal, this.reporte, this.filtro)
      .then(({data}) => (data.save()))
      .finally(() => (this.exportando = false))
  }
}

module.component('viaticosTodosLista', {
  controller: ViaticosTodosListaComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/todos/lista/component.js